<app-navbar *ngIf="showHeader" (onShowFilters)="showFilters($event)"></app-navbar>
<app-file-filters *ngIf="isShowingFilters" (onClose)="closeFilters()" (onClickSearch)="onClickSearch($event)"></app-file-filters>
<section class="body-content" *ngIf="!isShowingFilters">
    <ng-content></ng-content>
</section>
<app-footer *ngIf="showFooter"></app-footer>
<app-full-loader *ngIf="isLoading"></app-full-loader>